<template>
    <div class="feed-back">
        <p><span class="tag">*</span>反馈内容</p>
        <textarea placeholder="我认为..." v-model="feedBackForm.contents"></textarea>
        <div class="error-msg">{{errorMsg}}</div>
        <p><span class="tag">*</span>姓名</p>
        <input type="text" placeholder="请输入姓名" v-model="feedBackForm.name">
		<div class="error-msg">{{nameErrorMsg}}</div>
        <p><span class="tag">*</span>手机号</p>
        <input type="text" placeholder="请输入手机号" v-model="feedBackForm.phone">
		<div class="error-msg">{{phoneErrorMsg}}</div>
        <p><span class="tag">*</span>邮箱</p>
        <input type="text" placeholder="请输入邮箱地址" v-model="feedBackForm.email">
		<div class="error-msg">{{emailErrorMsg}}</div>
        <button :disabled="disabled" :class="{'submit-btn':true,'submiting':submiting}" ref="sendBtn" @click="sendContent">提交</button>
    </div>
</template>

<script>
import {AxiosOld} from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name:'FeedBack',
	data(){
		return{
			submiting:false,             //表单提交中按钮样式控制
			disabled:false,             //表单提交中按钮可点击状态
			errorMsg:'',                 //未输入反馈内容错误提示
			nameErrorMsg:'',
			phoneErrorMsg:'',
			emailErrorMsg:'',
			feedBackForm:{              //反馈内容表单
				contents:'',
                name:'',
                phone:'',
                email:''
			}
		}
	},
	methods:{
		sendContent(){
			if(this.feedBackForm.contents==""){
				this.errorMsg="表单信息不完整"
				return
			}else{
				this.errorMsg=""
			}
			if(this.feedBackForm.name==""){
				this.nameErrorMsg="表单信息不完整"
				return
			}else{
				this.nameErrorMsg=""
			}
			if(this.feedBackForm.phone==""){
				this.phoneErrorMsg="表单信息不完整"
				return
			}else{
				this.phoneErrorMsg=""
			}
			if(this.feedBackForm.email==""){
				this.emailErrorMsg="表单信息不完整"
				return
			}else{
				this.emailErrorMsg=""
			}
			this.submiting=true
			this.disabled=true
			this.$refs.sendBtn.innerHTML="提交中..."
			AxiosOld.post('/common/feedback',this.feedBackForm)
			.then(
				response=>{
					if(response.data.code==200&&response.data.status=="success"){
						this.submiting=false
						this.disabled=false
						this.$refs.sendBtn.innerHTML="提交"
						this.feedBackForm.contents=""
						this.feedBackForm.name=""
						this.feedBackForm.phone=""
						this.feedBackForm.email=""
						this.$swal({
							text:'提交成功 感谢您的宝贵建议',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						})
						setTimeout(()=>{
							location.href='/'
						},1200)
					}
				}
			).catch(
				error=>{
					this.submiting=false
					this.disabled=false
					this.$refs.sendBtn.innerHTML="提交"
					this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					});
				}
			)
		}
	}
}
</script>

<style lang="scss" scoped>
    .feed-back{
        padding:38px 56px;
        padding-top:118px;
        p{
            font-size:24px;
            color:#222;
            margin:30px 0;
            .tag{
                margin-right:10px;
                color:#bf0000;
            }
        }
        textarea{
            padding:30px;
            width:582px;
            height:300px;
            border-radius:12px;
            background:#F8F6F7;
            border:none;
            color:#999;
            margin-bottom:12px;
			font-size:26px;
        }
        textarea::placeholder{
            color:#ccc;
        }
        .error-msg{
            color:#bf0000;
			font-size:24px;
			height:24px;
			padding-left:20px;
			padding-top:6px;
        }
        input{
            width:610px;
			height:30px;
			line-height:26px;
			padding:20px 0 20px 30px;
            color:#999;
            background:#F8F6F7;
            border:none;
            border-radius:35px;
			font-size:26px;
        }
        input::-webkit-input-placeholder{
            color:#ccc;
			line-height:30px;
        }
        .submit-btn{
            width:640px;
            height:70px;
            line-height:70px;
            text-align:center;
            color:#fff;
            border-radius:35px;
            margin-top:60px;
            background:#bf0000;
			font-size:26px;
			border:none;
        }
        .submit-btn:active{
            background:#DD8080;
        }
		.submiting{
			background:#DD8080;
		}
    }
</style>